/* Sofina product gallery: previous / next arrows, keyboard arrows, swipe, counter.
   Drives the existing thumb buttons so variant filtering keeps working. */
(function () {
  var CSS = [
    '[data-sp2-stage]{position:relative;touch-action:pan-y}',
    '[data-sp2-stage] > .sfg-btn{position:absolute;inset:50% auto auto auto;transform:translateY(-50%);z-index:4;width:44px;height:44px;display:none;align-items:center;justify-content:center;padding:0;margin:0;border:1px solid rgba(44,44,44,.16);background:rgba(255,255,255,.9);color:#2C2C2C;cursor:pointer;transition:background .18s,border-color .18s}',
    '.sfg-on [data-sp2-stage] > .sfg-btn,.sfg-on > [data-sp2-stage] > .sfg-btn{display:flex}',
    '[data-sp2-stage] > .sfg-btn:hover{background:#fff;border-color:rgba(44,44,44,.42)}',
    '[data-sp2-stage] > .sfg-btn:focus-visible{outline:2px solid #A8894F;outline-offset:2px}',
    '[data-sp2-stage] > .sfg-btn svg{width:17px;height:17px;display:block}',
    '[data-sp2-stage] > .sfg-prev{left:16px;right:auto}',
    '[data-sp2-stage] > .sfg-next{right:16px;left:auto}',
    '[data-sp2-stage] > .sfg-count{position:absolute;inset:auto 16px 16px auto;z-index:4;display:none;width:auto;height:auto;pointer-events:none;padding:5px 10px;margin:0;font-size:12px;font-weight:500;letter-spacing:.06em;line-height:1.3;color:#2C2C2C;background:rgba(255,255,255,.9);border:1px solid rgba(44,44,44,.16);font-variant-numeric:tabular-nums}',
    '.sfg-on [data-sp2-stage] > .sfg-count,.sfg-on > [data-sp2-stage] > .sfg-count{display:block}',
    '@media(max-width:749px){[data-sp2-stage] > .sfg-btn{width:38px;height:38px}[data-sp2-stage] > .sfg-prev{left:10px}[data-sp2-stage] > .sfg-next{right:10px}[data-sp2-stage] > .sfg-btn svg{width:15px;height:15px}[data-sp2-stage] > .sfg-count{inset:auto 10px 10px auto;padding:4px 8px;font-size:11px}}',
    '@media(prefers-reduced-motion:reduce){[data-sp2-stage] > .sfg-btn{transition:none}}'
  ].join('');

  function injectCss() {
    if (document.getElementById('sfg-css')) return;
    var s = document.createElement('style');
    s.id = 'sfg-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function arrow(dir) {
    var d = dir === 'prev' ? 'M15 4 L7 12 L15 20' : 'M9 4 L17 12 L9 20';
    return "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round' aria-hidden='true'><path d='" + d + "'/></svg>";
  }

  function setup(gal) {
    if (gal.__sfg) return;
    var stage = gal.querySelector('[data-sp2-stage]');
    if (!stage) return;
    gal.__sfg = true;

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'sfg-btn sfg-prev';
    prev.setAttribute('aria-label', 'Previous image');
    prev.innerHTML = arrow('prev');

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'sfg-btn sfg-next';
    next.setAttribute('aria-label', 'Next image');
    next.innerHTML = arrow('next');

    var count = document.createElement('div');
    count.className = 'sfg-count';
    count.setAttribute('aria-hidden', 'true');

    stage.appendChild(prev);
    stage.appendChild(next);
    stage.appendChild(count);

    function thumbs() {
      var all = gal.querySelectorAll('[data-sp2-thumb]');
      var out = [];
      for (var i = 0; i < all.length; i++) {
        if (all[i].offsetParent !== null) out.push(all[i]);
      }
      return out;
    }

    function currentIndex(list) {
      for (var i = 0; i < list.length; i++) {
        if (list[i].getAttribute('aria-current') === 'true') return i;
      }
      var active = stage.querySelector('[data-sp2-media][data-active]');
      if (active) {
        var id = active.getAttribute('data-sp2-media');
        for (var j = 0; j < list.length; j++) {
          if (list[j].getAttribute('data-sp2-thumb') === id) return j;
        }
      }
      return 0;
    }

    function sync() {
      var list = thumbs();
      if (list.length < 2) {
        gal.classList.remove('sfg-on');
        return;
      }
      gal.classList.add('sfg-on');
      count.textContent = (currentIndex(list) + 1) + ' / ' + list.length;
    }

    function go(step) {
      var list = thumbs();
      if (list.length < 2) return;
      var i = currentIndex(list);
      var target = list[(i + step + list.length) % list.length];
      target.click();
      try {
        target.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      } catch (e) {
        target.scrollIntoView();
      }
      sync();
    }

    prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(-1); });
    next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(1); });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      if (e.metaKey || e.ctrlKey || e.altKey) return;
      var t = e.target;
      if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
      var r = stage.getBoundingClientRect();
      if (!(r.bottom > 0 && r.top < (window.innerHeight || 0))) return;
      if (thumbs().length < 2) return;
      e.preventDefault();
      go(e.key === 'ArrowLeft' ? -1 : 1);
    });

    var x0 = null, y0 = null;
    stage.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { x0 = null; return; }
      x0 = e.touches[0].clientX;
      y0 = e.touches[0].clientY;
    }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null || !e.changedTouches.length) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
      go(dx < 0 ? 1 : -1);
    }, { passive: true });

    var pending = null;
    var mo = new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () { pending = null; sync(); }, 60);
    });
    mo.observe(gal, { attributes: true, childList: true, subtree: true, attributeFilter: ['aria-current', 'data-active', 'style', 'hidden', 'class'] });

    sync();
    window.addEventListener('resize', sync);
  }

  function init() {
    injectCss();
    var gals = document.querySelectorAll('[data-sp2-gallery]');
    for (var i = 0; i < gals.length; i++) setup(gals[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();